export default "__VITE_ASSET__BPUne28n__"